import { useState } from 'react'
import { SnackbarType } from '../../control/Snackbar'

const useSnackbar = () => {
    const [open, setOpen] = useState(false)
    const [type, setType] = useState<SnackbarType>()

    const handleOpen = (type: SnackbarType) => {
        setOpen(true)
        setType(type)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return {
        open,
        type,
        onOpen: handleOpen,
        onClose: handleClose,
    }
}

export default useSnackbar
